import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { PageTabRail } from '@interxfi/app-components/components/page-tab-rail/page-tab-rail';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import DownloadIcon from '@interxfi/design-system/icons/react/icon-download';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { IceGsmInstrumentExportDownloadDialog } from '../../../../../../../../../../features/vendor/ice/global-security-master/instrument/ice-gsm-instrument-export-download-dialog';
import {
  IceGsmInstrumentsTable,
  type IceGsmInstrumentTableHeaderProps,
} from '../../../../../../../../../../features/vendor/ice/global-security-master/instrument/ice-gsm-instruments-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/instrument/_instrument/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorIce,
      label: 'Instruments',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorIce>,
  head: () => getPageHead('ICE GSM Instruments'),
  component: IceGsmInstrumentList,
});

function TableHeader({ filter, search }: IceGsmInstrumentTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <PageTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            <IceGsmInstrumentExportDownloadDialog
              trigger={<Button affixIcon={<DownloadIcon aria-hidden />} aria-label="Download CSV Export" size="small" />}
            />

            {filter}
          </HorizontalStack>
        }
        group={TabbedNavigationGroup.ClearingVendorIce}
      />

      {search}
    </VerticalStack>
  );
}

function IceGsmInstrumentList() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <IceGsmInstrumentsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
